
import { Component, Vue, Mixins, Prop, Watch, Emit } from "vue-property-decorator";
import RegionData from "@/mixins/regionData";
import GetStoreByRemote from "@/mixins/getStoreByRemote";

import dayjs from "dayjs";

import {
  editUserInfo,
  getUserInfo,
  logoutUser as logoutUserApi,
} from "@/api/userMember";

import { getCountryCodeList } from "@/api/common";

import { find } from "lodash";
import { age2Birthday } from "@/utils/common";

@Component
export default class BasicInfo extends Mixins(RegionData, GetStoreByRemote) {
  @Prop({ default: {} }) readonly parentData: any;
  @Prop({ default: "" }) readonly userId?: string;
  @Prop({ default: 0 }) readonly userStatus?: number;
  @Prop({ default: "" }) readonly storeName?: string;
  formData =
    {
      id: "",
      gender: 1,
      realName: "",
      phone: "",
      birthday: "",
      height: "",
      weight: "",
      address: [""],
      career: "",
      age: "",
      areaCode: "",
      storeId: "",
      storeShowName: "",
    };
  userVipInfo = {};
  pickerOptions = {
    disabledDate(date: Date) {
      if (dayjs(date).isAfter(dayjs())) return true;
      return false
    }
  }
  rules = {
    areaCode: [{ required: true, message: "请选择国家地区", validator: this.validateAreaCode, trigger: 'blur' }]
  };
  loading = false;
  btnLoading = false

  countryCodeList = [];

  originalUserPhone = "";


  validateAreaCode(rule, value, callback) {
    if (this.formData.areaCode && this.formData.phone) {
      callback();
      return;
    }
    return callback(new Error())
  }

  mounted() {
    // @ts-ignore
    this.$refs.validateForm?.resetFields()
    this.loading = true;
    getUserInfo({ id: this.userId }).then((res) => {
      const { gender = 1, realName, phone, birthday, height, weight, address = "", career, areaCode, storeId, storeName, storeShowName } = res.data || {};
      const age = this.calcAge(birthday);
      this.originalUserPhone = phone;
      Object.assign(this.formData, { storeShowName, areaCode: areaCode || "", age, gender, realName, phone, birthday, height, weight, address: address ? address.split(",") : [], career, storeId: storeId || "" })
      // 回显门店
      if (storeId) {
        this.allStoreList = [{ id: storeId, storeName, storeShowName  }]
      } 
      this.getCountryCodeList()
    }).finally(() => {
      this.loading = false;
    })
  }

  storeChange($event) {
    const store = find(this.allStoreList, ["id", $event]);
    this.formData.storeShowName = store?.storeShowName;
  }

  getCountryCodeList() {
    getCountryCodeList().then((res) => {
      const { list = [], _default } = res.data;
      this.countryCodeList = list;
      // this.formData.areaCode = _default.areaCode;
    })
  }

  calcAge(birthday) {
    if (!birthday) return "";
    const bir = dayjs(birthday);
    const now = dayjs();
    const diff = now.diff(bir, "year");
    if (diff < 0) return "0"
    return `${diff}`
  }

  addressChange($event: any) {
    console.log($event)
    console.log(this.formData)
  }

  phoneInput(newValue: string) {
    this.formData.phone = newValue.replace(/[^(\d)]/g,'');
  }
  
  heiWeiInput(newValue: string, key: string) {
    if (newValue == "") return "";
    // @ts-ignore
    this.formData[key] = newValue.replace(/[^(\d)]/g,'');
  }

  // NOTE: 先保留着
  // dialogConfirm() {
  //   let params = {
  //     id: this.formData.id,
  //     nickname: this.formData.nickname,
  //     phone: this.formData.phone,
  //     gender: this.formData.gender,
  //   };
  //   // @ts-ignore
  //   this.$refs["validateForm"]?.validate((valid: any) => {
  //     if (valid) {
  //       updateUser(params)
  //         .then((res) => {
  //           this.handleClose();
  //           this.getData();
  //         })
  //         .catch((err) => { });
  //     } else {
  //       console.log("error submit!!");
  //       return false;
  //     }
  //   });

  logoutUser() {
    const message = `
      <div style="margin-bottom: 10px;">确认注销该手机号，注销后无法恢复？</div>
      <div style="color: #F56C6C; margin-top: 10px; font-size: 13px;">
        <div style="margin-bottom: 5px;">注销用户手机号后需提醒用户删掉公司小程序后重新进小程序。</div>
        <div>注意:注销手机号可能会影响门店数据统计。</div>
      </div>
    `;
    this.$confirm(message, "提示", {
      confirmButtonText: "确认",
      cancelButtonText: "取消",
      type: "warning",
      dangerouslyUseHTMLString: true,
    }).then(() => {
      this.btnLoading = true;
      logoutUserApi({ phone: this.originalUserPhone })
        .then((res) => {
          this.$message.success("注销成功");
          this.handleClose();
          this.getData();
        })
        .catch((err) => {
        })
        .finally(() => {
          this.btnLoading = false;
        });
    }).catch(() => {
      // User cancelled, do nothing
    });
  }

  dialogConfirm() {
    const { gender, realName, phone, birthday, height, weight, address, career, areaCode, storeId } = this.formData;
    console.log(!this.formData.age)
    if (!this.formData.age) {
      this.$message.error('请填写年龄');
      return;
    }
    if(parseInt(this.formData.age) <= 0 || parseInt(this.formData.age) >= 150) {
      this.$message.error('年龄请输入0到150之间的数字');
      return;
    }
    if(parseInt(this.formData.height, 10) < 50 || parseInt(this.formData.height, 10) > 300) {
      this.$message.error('身高请输入50到300之间的数字');
      return;
    }
    if(parseInt(this.formData.weight, 10) < 10 || parseInt(this.formData.weight, 10) > 400) {
      this.$message.error('体重请输入10到400之间的数字');
      return;
    }
    let params = {
      id: this.userId,
      gender, realName, phone, 
      birthday: age2Birthday(this.formData.age), 
      height, weight, address: address.join(","), career, areaCode,
      storeId
    };
    this.btnLoading = true;
    // @ts-ignore
    this.$refs["validateForm"]?.validate().then(() => {
      editUserInfo(params)
        .then((res) => {
          this.handleClose();
          this.getData();
        }).finally(() => {
          this.btnLoading = false;
        })
    }).catch((err) => {
      this.btnLoading = false;
    });
  }

  @Watch("parentData", { immediate: true, deep: true })
  setFormData(value: any) {
  }

  @Emit("handleClose")
  handleClose() {
    return false;
  }

  @Emit("getData")
  getData() {
    return true;
  }

}
